export const stripHtml = (htmlText) => htmlText.replace(/<\/?[^>]+(>|$)/g, '');
//# sourceMappingURL=helpers.js.map